import { Link } from 'react-router-dom';

const FunctionalRoleHelperLinks = () => {
	return (
		<>
			<strong>
				Click{' '}
				<Link
					to={{
						pathname:
							'https://infonet.upmc.com/infonet/ls/content/8967325090444803/epic-role-descriptions-pdf-1764800962',
					}}
					label='here'
					target='_blank'
				>
					here
				</Link>{' '}
				to see Registration, Billing, and Scheduling role
				information/descriptions.
			</strong>
		</>
	);
};

export default FunctionalRoleHelperLinks;
